var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.143 3.143h5.714c.286 0 .572-.286.572-.572 0-.285-.286-.571-.572-.571H7.143c-.286 0-.572.286-.572.571 0 .286.286.572.572.572zm10.286 1.714H2.57c-.285 0-.571.286-.571.572 0 .285.286.571.571.571H17.43c.285 0 .571-.286.571-.571 0-.286-.286-.572-.571-.572zm-2.286 2.286c-.343 0-.572.228-.572.571V16.4a.492.492 0 01-.457.457H5.886a.492.492 0 01-.457-.457V7.714c0-.343-.229-.571-.572-.571-.343 0-.571.228-.571.571V16.4c0 .857.743 1.6 1.6 1.6h8.228c.857 0 1.6-.743 1.6-1.6V7.714c0-.343-.228-.571-.571-.571z",
    fill: "#191C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.877 7.274c.579-.193.723-.101.837.012a.624.624 0 01.193.428h0V14a.624.624 0 01-.193.428.624.624 0 01-.428.193.624.624 0 01-.429-.193.624.624 0 01-.193-.428h0V7.714a7.97 7.97 0 01.202-.436l.011-.004zm3.429 0c.578-.193.723-.101.836.012a.624.624 0 01.194.428h0V14a.624.624 0 01-.193.428.624.624 0 01-.429.193.624.624 0 01-.428-.193.624.624 0 01-.193-.428h0V7.714c.196-.43.199-.434.202-.436l.01-.004z",
    stroke: "#3B65EE",
    strokeWidth: 0.1,
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/assets/icon-delete.fb0259df.svg";
export { ForwardRef as ReactComponent };